import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { VoiceReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: VoiceReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    voiceAppIds: report.voiceAppIds,
    msisdns: report.msisdns,
    operators: report.operators,
    operationIds: report.operationIds,
    sessionTags: report.sessionTags,
    sessionCloseReasons: report.sessionCloseReasons
  }
});
